<div class="row justify-content-center unselectable">
  <div class="col-1"></div>
  <a href="https://www.cartec.ch/" class="col-2 logo">
    <img class="logoImage" src="../../../assets/logos/Cartec-Logo_1c_neg.svg" alt="cartecLogo"/>
  </a>
  <a href="http://www.wheelnews.ch/" class="col-2 logo">
    <img class="logoImage" src="../../../assets/logos/wheelnews_RGB_neg.svg" alt="wheelNewsLogo"/>
  </a>
  <a href="https://www.cotra.ch/" class="col-2 logo">
    <img class="logoImage" src="../../../assets/logos/Cotra_1c_neg.svg" alt="cotraLogo"/>
  </a>
  <a href="https://www.airportparking.ch/" class="col-2 logo">
    <img class="logoImage" src="../../../assets/logos/APP-Logo_1c_neg.png" alt="airportParkingLogo"/>
  </a>
  <div class="col-1"></div>
</div>
